import { useTranslation } from "react-i18next";
import CustomInputField from "components/common/CustomInputField";
import React from "react";
import { Form, Modal } from "reactstrap";
import { ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import { useFormik } from "formik";
import BtnCustom from "components/common/btn-custom";
import { successToaster } from "components/common/toast";
import { CategorySchema } from "components/schema/CategorySchema";
import { CreateSectionCategoriesAPI } from "network/categoryAPI";
import { UpdateSectionCategoriesAPI } from "network/categoryAPI";
export default function AddCategorySectionModal({
  ModelOpen,
  setModalOpen,
  setFetchTrigger,
  editCategory,
  sectionData,
  setCategory,
}) {
  const { t } = useTranslation("common");
  const handleCloseModel = () => {
    setModalOpen(false);
  };
  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
  } = useFormik({
    initialValues: {
      name: editCategory?.name || "",
      description: editCategory?.description || "",
    },
    enableReinitialize: true,
    validationSchema: CategorySchema,
    onSubmit: async (values) => {
      try {
        if (editCategory?.uuid) {
          const response = await UpdateSectionCategoriesAPI(
            sectionData?.uuid,
            editCategory?.uuid,
            values
          );
          if (response.success) {
            successToaster(response.message);

            setCategory((prev) =>
              prev.map((item) =>
                item?.uuid === response?.data?.uuid ? response?.data : item
              )
            );

            setModalOpen(false);
          }
        } else {
          const response = await CreateSectionCategoriesAPI(
            sectionData?.uuid,
            values
          );
          if (response.success) {
            successToaster(response.message);
            setFetchTrigger((prev) => !prev);
            setModalOpen(false);
          }
        }
      } catch (error) {
        console.error("Error:", error);
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });

  return (
    <div>
      <Modal isOpen={ModelOpen} toggle={handleCloseModel} className="modal-md">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {editCategory?.uuid ? t("categoryModal.updateTitle") : t("categoryModal.addTitle")}
          </h5>
          <button
            aria-label={t("actions.close")}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCloseModel}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleSubmit}>
            <div>
              <CustomInputField
                label={t("categoryModal.name")}
                name="name"
                placeholder={t("categoryModal.name")}
                type="text"
                errors={errors}
                touched={touched}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values}
              />
            </div>
            <div>
              <CustomInputField
                label={t("categoryModal.description")}
                name="description"
                placeholder={t("categoryModal.descriptionPlaceholder")}
                type="textarea"
                errors={errors}
                touched={touched}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values}
              />
            </div>
            <BtnCustom
              className="btn-round"
              color="primary"
              size="lg"
              type="submit"
              isLoading={isSubmitting}
              submittingText={editCategory?.uuid ? t("actions.updating") : t("actions.adding")}
            >
              {editCategory?.uuid ? t("categoryModal.updateTitle") : t("categoryModal.addTitle")}
            </BtnCustom>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
